import { render, staticRenderFns } from "./policyList.vue?vue&type=template&id=6d8f70e8&scoped=true&"
import script from "./policyList.vue?vue&type=script&lang=js&"
export * from "./policyList.vue?vue&type=script&lang=js&"
import style0 from "./policyList.vue?vue&type=style&index=0&id=6d8f70e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f70e8",
  null
  
)

export default component.exports